import { Injectable, Injector } from '@angular/core';
import { cacheImageSourcePixels } from '../../../../cross-team-shared/state/sensor-renderer-state';
import { LoadImageService } from '../../../../shared/misc-services/load-image.service';
import { AbstractRasterCodingTool } from '../abstract-raster-coding-tool';
import { FloodfillDragHandler } from './floodfill-drag-handler';

@Injectable()
export class FloodfillTool extends AbstractRasterCodingTool {
  readonly name = 'Fill';

  constructor(
    private loadImageService: LoadImageService,
    injector: Injector,
  ) {
    super(injector);
  }

  override async onActivate() {
    await super.onActivate();
    await cacheImageSourcePixels(this.loadImageService, this.store);
    this.onEvent('container', 'mousedown', this.startPainting);
    this.onEvent('container', 'mousedown', this.startPainting, {
      modifiers: ['altKey'],
    });
  }

  override onCancel() {
    // we may want to make escape cancel a floodfill some time. For now, this
    // empty method makes escape not break things.
  }

  startPainting(initialEvent: MouseEvent) {
    const dragHandler = new FloodfillDragHandler(
      this.getCode(initialEvent),
      initialEvent,
      this.injector,
    );
    dragHandler.drag();

    this.registerHelper(dragHandler);
  }
}
